<template>
    <div v-for="(record, index) in history" :key="record.id ?? record.history_id ?? index" class="mb-3">
        <ShiftHistoryListItem :record :previous-record="history[index + 1]" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/stores/scheduleStore';
import ShiftHistoryListItem from './ShiftHistoryListItem.vue';

const store = useScheduleStore()
const history = computed(() => store.shiftHistory)
</script>
